export default __webpack_public_path__ + "static/media/angels.c9979445.svg";